import { getCookie } from 'utils/cookies';

export interface ApiError {
  errorType?: string;
  message?: string;
}

const HUBSPOT_ACCOUNT_ID = '21263470';

const useFormSubmit = () => {
  const submitForm = (
    formId: string,
    data: Record<string, unknown>,
    onSuccess: () => void,
    onError: (errors?: ApiError[]) => void
  ) => {
    const url = `https://api.hsforms.com/submissions/v3/integration/submit/${HUBSPOT_ACCOUNT_ID}/${formId}`;

    const fields = data
      ? Object.entries(data)
          .filter(([key, value]) => value)
          .map(([key, value]) => {
            return {
              name: key,
              value
            };
          })
      : undefined;

    const request = {
      submittedAt: Date.now(),
      fields,
      context: {
        hutk: getCookie('hubspotutk'),
        pageUri: window?.location?.href,
        pageName: document.title
      }
      // legalConsentOptions: {
      //   // Include this object when GDPR options are enabled
      //   consent: {
      //     consentToProcess: true,
      //     text: 'I agree to allow Example Company to store and process my personal data.',
      //     communications: [
      //       {
      //         value: true,
      //         subscriptionTypeId: 999,
      //         text: 'I agree to receive marketing communications from Example Company.'
      //       }
      //     ]
      //   }
      // }
    };

    const headers = { 'content-type': 'application/json' } as Record<string, string>;
    fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: headers,
      body: JSON.stringify(request)
    })
      .then((response) => {
        response
          .json()
          .then((body) => {
            console.debug('request sent', response.status, response.statusText, body);
            if (!response.ok) {
              onError(body?.errors);
            } else {
              onSuccess();
            }
          })
          .catch((err) => onError(err));
      })
      .catch((err) => {
        console.warn('request not sent', err);
        onError(err);
      });
  };

  return { submitForm };
};

export default useFormSubmit;
